var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1459_5662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.125 12.5C3.125 14.3233 3.84932 16.0721 5.13864 17.3613C6.42795 18.6507 8.17663 19.375 10 19.375C11.8233 19.375 13.5721 18.6507 14.8613 17.3613C16.1507 16.0721 16.875 14.3233 16.875 12.5C16.875 10.6767 16.1507 8.92792 14.8613 7.63864C13.5721 6.34933 11.8233 5.625 10 5.625C8.17663 5.625 6.42795 6.34933 5.13864 7.63864C3.84932 8.92792 3.125 10.6767 3.125 12.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 12.5C8.125 12.9972 8.32254 13.4742 8.67417 13.8258C9.02583 14.1774 9.50275 14.375 10 14.375C10.4972 14.375 10.9742 14.1774 11.3258 13.8258C11.6774 13.4742 11.875 12.9972 11.875 12.5C11.875 12.0027 11.6774 11.5258 11.3258 11.1742C10.9742 10.8226 10.4972 10.625 10 10.625C9.50275 10.625 9.02583 10.8226 8.67417 11.1742C8.32254 11.5258 8.125 12.0027 8.125 12.5Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 7.19583V5C5.625 3.83968 6.08593 2.72688 6.90641 1.90641C7.72688 1.08593 8.83967 0.625 10 0.625C11.1603 0.625 12.2731 1.08593 13.0936 1.90641C13.9141 2.72688 14.375 3.83968 14.375 5V7.19583",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1459_5662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.82c674851b3c3f0811af1203dd1db698.svg";
export { ForwardRef as ReactComponent };